import {
  AssetExportExchangeDocument,
  AssetsListDocument,
  AssetsGroupedByAssetPaginatedDocument,
  AssetsGroupedByExchangeDocument,
  AssetsGroupedByExchangeTypeAndAssetDocument,
  AssetsGroupedByExchangeTypeDocument,
  AssetExchangeExportFileTypeDocument,
} from "api/generated";
import { RequestTypes } from "api/services/enums";
import { getRequestInstance } from "api/services/utils";

import {
  IAssetExchangeModel,
  IGetExchangeListGroupByExchangeArgs,
  IGetExchangeListGroupedByExchangeResponse,
  IGetExchangeListGroupedByAssetArgs,
  IGetExchangeListGroupedByAssetResponse,
  IGetExchangeListGroupedByExchangeTypeArgs,
  IGetExchangeListGroupedByExchangeTypeResponse,
  IGetExchangeListGroupedByExchangeTypeAndAssetResponse,
  IGetExchangeListGroupedByExchangeTypeAndAssetArgs,
  IExportExchangesArgs,
} from "./types";

export async function getAssets(): Promise<IAssetExchangeModel[]> {
  const makeRequest = getRequestInstance(RequestTypes.QUERY);
  const res = await makeRequest({
    query: AssetsListDocument,
    fetchPolicy: "network-only",
  });

  return res?.data?.assetsList ?? [];
}

export async function getExchangesListGroupedByAsset(
  variables?: IGetExchangeListGroupedByAssetArgs
): Promise<IGetExchangeListGroupedByAssetResponse> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: AssetsGroupedByAssetPaginatedDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.assetsGroupedByAssetPaginated;
  } catch (error) {
    throw error;
  }
}

export async function getExchangesListGroupedByExchange(
  variables?: IGetExchangeListGroupByExchangeArgs
): Promise<IGetExchangeListGroupedByExchangeResponse> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: AssetsGroupedByExchangeDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.assetsGroupedByExchangePaginated;
  } catch (error) {
    throw error;
  }
}

export async function getExchangeListGroupedByExchangeType(
  variables?: IGetExchangeListGroupedByExchangeTypeArgs
): Promise<IGetExchangeListGroupedByExchangeTypeResponse> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: AssetsGroupedByExchangeTypeDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.assetsGroupedByExchangeTypePaginated;
  } catch (error) {
    throw error;
  }
}

export async function getExchangeListGroupedByExchangeTypeAndAsset(
  variables?: IGetExchangeListGroupedByExchangeTypeAndAssetArgs
): Promise<IGetExchangeListGroupedByExchangeTypeAndAssetResponse> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: AssetsGroupedByExchangeTypeAndAssetDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.assetsGroupedByExchangeTypeAndAssetPaginated;
  } catch (error) {
    throw error;
  }
}

export async function getExchangeExportFileTypes(): Promise<string[]> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: AssetExchangeExportFileTypeDocument,
      fetchPolicy: "cache-first",
    });

    return res?.data?.assetExchangeExportFileType ?? [];
  } catch (error) {
    throw error;
  }
}

export async function exportExchangeFile(
  variables: IExportExchangesArgs
): Promise<string> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: AssetExportExchangeDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.assetExport;
  } catch (error) {
    throw error;
  }
}
